module.exports = __webpack_public_path__ + "static/img/26829.a54c59a.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/jys/26829.png
// module id = jwA7
// module chunks = 0